import { ValidationRule } from './basic';

export type ValueSource = 'value' | 'field';

export const RuleCombinator = {
  IF: 'IF',
  AND: 'AND',
  OR: 'OR',
} as const;
export type RuleCombinator = (typeof RuleCombinator)[keyof typeof RuleCombinator];

interface CommonProperties {
  path?: number[];
  id?: string;
  disabled?: boolean;
}

export type RuleType<
  F extends string = string,
  O extends string = string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  V = any[],
> = CommonProperties & {
  id: string;
  field: F;
  operator: O;
  values: V;
  valueSource?: ValueSource;
  validationRule?: ValidationRule;
};

export type RuleGroupType = CommonProperties & {
  combinator: RuleCombinator;
  rules: RuleType[];
};
